import { useTranslation } from 'react-i18next';
import { Avatar } from 'src/components/Avatar';
import { Box } from 'src/components/Box';
import { Card, CardContent } from 'src/components/Card';
import { Typography } from 'src/components/Typography';
import { useSession } from 'src/contexts/SessionContext';
import { LeaderboardMeData } from 'src/models/leaderboard/_types';

interface LeaderboardMeProps {
  me: LeaderboardMeData;
  showNextTier?: boolean;
}

export const LeaderboardMe = ({
  me,
  showNextTier = true,
}: LeaderboardMeProps) => {
  const { user } = useSession();
  const { t } = useTranslation('translation', {
    keyPrefix: 'leaderboard.public',
  });

  return (
    <Card variant="outlined" sx={{ m: 2 }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Avatar src={user?.profileImage} sx={{ width: 44, height: 44 }} />
          <Box sx={{ mr: 3 }}>
            <Typography variant="caption" color="text.secondary">
              {t('rank')}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {me.rank}
            </Typography>
          </Box>
          <Box sx={{ mr: 3 }}>
            <Typography variant="caption" color="text.secondary">
              {t('percentile')}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {Math.round(me.percentile * 100)}%
            </Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('score')}
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {me.value}
            </Typography>
          </Box>
        </Box>
        {showNextTier && me.nextTier && (
          <Typography sx={{ mt: 1 }} variant="body2">
            {me.nextTier}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
